import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import useAuthUser from "react-auth-kit/hooks/useAuthUser";
import LoadingSpinner from "../../../components/LoadingSpinner";
import { useAxiosInstance } from "../../../services/Interceptor";
import { getAdminProfile } from "../../../services/AdminService";

function AdminPersonalInfo() {
  const apiInstance = useAxiosInstance();
  const authUser = useAuthUser();
  const [isLoading, setIsLoading] = useState(false);
  const [profileData, setProfileData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    city: "",
    state: "",
  });

  useEffect(() => {
    const fetchProfile = async () => {
      if (!authUser?.user?.id) {
        return;
      }

      setIsLoading(true);
      try {
        const response = await getAdminProfile(apiInstance, authUser?.user?.id);
        setProfileData({
          firstName: response?.firstName ?? authUser?.user?.firstName ?? "",
          lastName: response?.lastName ?? authUser?.user?.lastName ?? "",
          email: response?.email ?? authUser?.user?.email ?? "",
          city: response?.city ?? "",
          state: response?.state ?? "",
        });
      } catch (error) {
        toast.error(
          "Error fetching personal info: " +
            (error?.message || "Something went wrong."),
        );
      } finally {
        setIsLoading(false);
      }
    };

    fetchProfile();
  }, [apiInstance, authUser]);

  return (
    <div className="bg-white shadow-lg p-4 rounded-lg border-gray-300">
      <div className="w-full px-4">
        <h1 className="text-xl mb-4 uppercase">Personal Info</h1>
        {isLoading ? (
          <div className="flex justify-center py-6">
            <LoadingSpinner />
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block uppercase tracking-wide text-gray-500 text-xs font-bold mb-2">
                First Name
              </label>
              <input
                type="text"
                readOnly
                value={profileData.firstName}
                className="appearance-none block w-full text-gray-900 border border-gray-300 rounded p-3 bg-gray-100"
              />
            </div>
            <div>
              <label className="block uppercase tracking-wide text-gray-500 text-xs font-bold mb-2">
                Last Name
              </label>
              <input
                type="text"
                readOnly
                value={profileData.lastName}
                className="appearance-none block w-full text-gray-900 border border-gray-300 rounded p-3 bg-gray-100"
              />
            </div>
            <div>
              <label className="block uppercase tracking-wide text-gray-500 text-xs font-bold mb-2">
                Email
              </label>
              <input
                type="text"
                readOnly
                value={profileData.email}
                className="appearance-none block w-full text-gray-900 border border-gray-300 rounded p-3 bg-gray-100"
              />
            </div>
            <div>
              <label className="block uppercase tracking-wide text-gray-500 text-xs font-bold mb-2">
                City
              </label>
              <input
                type="text"
                readOnly
                value={profileData.city}
                className="appearance-none block w-full text-gray-900 border border-gray-300 rounded p-3 bg-gray-100"
              />
            </div>
            <div>
              <label className="block uppercase tracking-wide text-gray-500 text-xs font-bold mb-2">
                State
              </label>
              <input
                type="text"
                readOnly
                value={profileData.state}
                className="appearance-none block w-full text-gray-900 border border-gray-300 rounded p-3 bg-gray-100"
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default AdminPersonalInfo;
